import { ApiResponse } from "@/interfaces/api-response";
import {
  AIFilter,
  AIFilterCategory,
  AIFilterProvider,
} from "@/interfaces/ai-filter.interface";
import apiClient from "@/utils/axios";

const SERVICE_ENDPOINT = "ai-filters";

type CreateOnePayload = Pick<
  AIFilter,
  "categoryId" | "fallbackId" | "name" | "provider" | "type" | "config" | "referenceImageUrls"
>;

const createOne = async (payload: CreateOnePayload) => {
  const response = await apiClient.post<ApiResponse<AIFilter>>(
    `/${SERVICE_ENDPOINT}`,
    payload,
  );
  return response.data;
};

const getMany = async (params: {
  sort?: string;
  page?: number;
  size?: number;
  search?: string;
  categoryId?: AIFilterCategory["_id"];
  provider?: AIFilterProvider;
  type?: string;
}) => {
  const response = await apiClient.get<ApiResponse<AIFilter[]>>(
    `/${SERVICE_ENDPOINT}`,
    {
      params,
    },
  );
  return response.data;
};

const getOneById = async (id: string, params?: object) => {
  const response = await apiClient.get<ApiResponse<AIFilter>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    { params },
  );
  return response.data;
};

const getGeminiModels = async () => {
  const response = await apiClient.get<
    ApiResponse<{
      models?: Array<{
        name?: string;
        description?: string;
      }>;
    }>
  >(`/${SERVICE_ENDPOINT}/gemini-models`);
  return response.data;
};

const getOpenAIModels = async () => {
  const response = await apiClient.get<
    ApiResponse<{
      data?: Array<{
        id?: string;
      }>;
    }>
  >(`/${SERVICE_ENDPOINT}/openai-models`);
  return response.data;
};

const updateOneById = async (
  id: string,
  data: Partial<AIFilter>,
  params?: object,
) => {
  const response = await apiClient.put<ApiResponse<AIFilter>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    data,
    { params },
  );
  return response.data;
};

const deleteOneById = async (id: string) => {
  const response = await apiClient.delete<ApiResponse<AIFilter>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const aiFilterApi = {
  createOne,
  getMany,
  getOneById,
  getGeminiModels,
  getOpenAIModels,
  updateOneById,
  deleteOneById,
};

export default aiFilterApi;
